import { ArrowDown, ArrowUp } from '@berlitz/icons'
import includes from 'lodash/includes'
import * as React from 'react'

import { Consumer } from './Context'
import { PanelProp } from './interface'
import { ChildWrapper, Header, HeaderButton, PanelBox, Title } from './style'

const Panel: React.FC<PanelProp> = ({ children, id, header, onClick, hideOnly }) => (
  <Consumer>
    {({ activeIds, toggle }) => {
      const isActive = includes(activeIds, id)

      return (
        <PanelBox>
          <Header
            active={isActive}
            onClick={() => {
              onClick && onClick(!isActive)
              toggle(id)
            }}
          >
            <Title className={isActive ? 'active' : 'inactive'}>{header}</Title>
            <HeaderButton active={isActive}>
              {isActive ? <ArrowUp size="md" color="brand03" /> : <ArrowDown size="md" color="brand02" />}
            </HeaderButton>
          </Header>
          {hideOnly ? <ChildWrapper active={isActive}>{children}</ChildWrapper> : isActive && children}
        </PanelBox>
      )
    }}
  </Consumer>
)

export default Panel
